export default __webpack_public_path__ + "static/media/lock.3ea3642b.svg";